<button mat-raised-button color="basic" class="archive-selected-processes-button" (click)="archiveSelectedProcesses()"
    [disabled]="!isActive">
    <mat-icon matTooltip="{{restore? 'Unarchive': 'Archive'}} selected processes">{{restore? 'unarchive': 'archive'}}
    </mat-icon>
</button>
